<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.fiqh' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الاسم' : 'Name' }}
  </label>

  <input
    type="text"
    class="form-control"
    [(ngModel)]="formData.name"
    name="name"
    placeholder="{{ lang === 'ar' ? 'الاسم' : 'Name' }}"
  />

  <small class="text-danger" *ngIf="errors?.name">
    {{ errors.name[0] }}
  </small>
</div>

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الرابط المختصر' : 'Slug' }}
  </label>

  <input
    type="text"
    class="form-control"
    [(ngModel)]="formData.slug"
    name="slug"
    placeholder="{{ lang === 'ar' ? 'الرابط المختصر' : 'Slug' }}"
  />

  <small class="text-danger" *ngIf="errors?.slug">
    {{ errors.slug[0] }}
  </small>
</div>

          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
